import React from "react";

export const Texas = (props) => {
  return (
    <div id="texas">
      <div className="container">
        <div className="proof-grid">
          <div className="proof-left">
            <div className="eyebrow">Our Approach</div>
            <h2>{props.data ? props.data.headline : "Built with Precision. Validated in the Field."}</h2>
            <p>{props.data ? props.data.paragraph : "loading..."}</p>
            <ul className="proof-points">
              {props.data && props.data.points
                ? props.data.points.map((point, i) => (
                    <li key={i}>
                      <span className="proof-check">&#10003;</span>
                      {point}
                    </li>
                  ))
                : null}
            </ul>
          </div>
          <div className="proof-right">
            <div className="proof-panel">
              <div className="proof-panel-label">Field-Validated Approach</div>
              {props.data && props.data.metrics
                ? props.data.metrics.map((m, i) => (
                    <div key={i} className="proof-metric">
                      <div className="proof-metric-label">{m.label}</div>
                      <div className="proof-metric-desc">{m.desc}</div>
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
